var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cpt-chat-room-avatar flex-center overflow-hidden relative",class:{
    '!bg-bd-fl': _vm.keep_active && !_vm.img
  },style:({
    width: _vm.width + 'px',
    height: _vm.width + 'px',
    'border-radius': _vm.radius + 'px'
  })},[(_vm.img)?[_c('ChatImg',_vm._b({staticClass:"default-img",attrs:{"src":_vm.img,"lazy":_vm.lazy,"animation":_vm.animation,"webp_quality":_vm.webp_quality,"thumbnail":`${_vm.width * (_vm.img.includes('.gif') ? 5 : 3)}x`},on:{"load":function($event){return _vm.$emit('load', $event)}}},'ChatImg',_vm.inject_chat_img_props,false))]:[(_vm.room_name)?_c('span',{directives:[{name:"emoji-html",rawName:"v-emoji-html",value:({text: _vm.getRoomIconStr(_vm.room_name, _vm.only_one_char), style: { width: _vm.icon_width + 'px', height: _vm.icon_width + 'px' }}),expression:"{text: getRoomIconStr(room_name, only_one_char), style: { width: icon_width + 'px', height: icon_width + 'px' }}"}],staticClass:"text-[12px] text-tx-3 font-bold",style:({
        fontSize: _vm.icon_width + 'px',
        color: _vm.keep_active ? '#fff' : ''
      })}):_c('i',{staticClass:"icon-room iconfont text-tx-4 m-0",style:({
        width: _vm.icon_width + 'px',
        height: _vm.icon_width + 'px',
        fontSize: _vm.icon_width + 'px',
        color: _vm.keep_active ? '#fff' : ''
      })})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }